<template>
    <div>
        <label v-if="label" class="label">{{ label }}</label>
        <e-autocomplete
            v-model="selected"
            clearable
            :data="data"
            :set-value="setValue"
            :set-selected="setValue"
            keep-first
            :label="label"
            field="name"
            :initial-data="initialData"
            open-on-focus
            :placeholder="placeholder"
            url-params="groups"
            :icon="includeIcon ? 'filter' : ''"
            append-to-body
            @typing="getAsyncData"
            @esc="$emit('update:modelValue', null)"
            @select="group => $emit('update:modelValue', group)"
            @clear="$emit('update:modelValue', null)"
        >
            <template #default="props">
                {{ props.option.name }}
            </template>
        </e-autocomplete>
        <div v-if="error" class="error-message">{{ error }}</div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce.js';

import axios from '@/plugins/axios.js';

export default {
    name: 'GroupSearch',

    props: {
        label: {
            type: String,
            required: false,
            default: '',
            value: '',
        },

        placeholder: {
            type: String,
            required: false,
            default: 'Type a group title...',
        },

        modelValue: {
            type: Object,
            required: false,
            default: () => ({}),
        },

        initialData: {
            type: Array,
            required: false,
            default: () => [],
        },

        setValue: {
            type: String,
            required: false,
            default: null,
        },

        presetId: {
            type: Number,
            required: false,
            default: null,
        },

        includeIcon: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            data: [],
            selected: null,
            isFetching: false,
            error: null,
        };
    },

    watch: {
        setValue(newValue) {
            this.selected = newValue;
        },
    },

    async created() {
        this.selected = this.setValue;

        if (this.presetId) {
            await this.setInitialData();
        }
    },

    emits: ['update:modelValue'],

    methods: {
        getAsyncData: debounce(async function getAsyncData(name) {
            if (!name?.length) {
                this.data = [];
                return;
            }

            this.isFetching = true;

            try {
                const { data } = await axios.get(`/api/groups?search=${name}`);
                this.data = data.data;
            } catch (error) {
                this.data = [];
                this.error = 'Failed to fetch groups. Please try again.';
                throw error;
            } finally {
                this.isFetching = false;
            }
        }, 500),

        async setInitialData() {
            try {
                const { data } = await axios.get(`/api/groups/${this.presetId}`);

                this.selected = data.data.name;
                this.$emit('update:modelValue', data.data);
                this.error = null;
            } catch (error) {
                this.error = 'Failed to fetch groups. Please try again.';
                console.error(error);
            }
        },
    },
};
</script>

<style>
.error-message {
    color: red;
    margin-top: 0.5rem;
    margin-bottom: -0.5rem;
}
</style>
